import useTrans from '@hooks/useTrans'
import styles from './BannerCard.module.sass'

import { Button, WImage } from '@components/atoms'
import { MenuItemType } from '@utils/types'

interface Props {
  className?: string
  item: MenuItemType
}

const BannerCard = (props: Props) => {
  const { className = '', item = undefined } = props

  const classeNames = `
  ${styles.root}
  ${className ? className : ''}`
  const t = useTrans()

  return item ? (
    <div className={`${styles.root} ${classeNames} `}>
      <div className={styles.bg}>
        <div className={styles.layout}>
          {item?.image && (
            <div className={styles.imageWrap}>
              <div className={styles.imageBox}>
                <WImage
                  src={item?.image}
                  maxWidth={610}
                  maxHeight={250}
                  objectFit={'cover'}
                  alt={item.imageAlt}
                  title={item.imageAlt}
                />
              </div>
            </div>
          )}
          <div className={styles.content}>
            {item?.name && <div className={styles.titolo}>{item.name}</div>}
            <div
              className={styles.descrizione}
              dangerouslySetInnerHTML={{ __html: item?.description }}
            />
            {!!item.url && !!item.ctaLabel && (
              <div className={styles.ctaBox}>
                <Button
                  label={item.ctaLabel}
                  href={item.url}
                  variant="ghost"
                  newPage={item.blank}
                  size="lg"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default BannerCard
